import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import append from '@mailobj-browser/front/js/tree/append.js'
import element from '@mailobj-browser/front/js/tree/element.js'
import wait from '@mailobj-browser/front/js/utils/wait.js'
import { closeByMessage } from './close.js'
import * as utilities from '#utilities/js/styles.js'

export default element => {
  const { ownerDocument, dataset } = element
  const { sticky } = dataset
  const divMessage = one('#div_MESSAGE', ownerDocument)
  if (divMessage) {
    const list = one('#id_msg_ul', divMessage)
    if (list) {
      const items = all('li', element)
      append(list, items)
      divMessage.removeAttribute('style') // @todo A supprimer quand full bundle
      divMessage.classList.add(utilities.modifiers.display.block)
      divMessage.classList.add(utilities.modifiers.visibility.visible)
      if (Number(sticky) > 0) {
        queueMicrotask(async () => {
          await wait(sticky)
          closeByMessage(list, items)
        })
      }
    }
  }
}

export const displayMessageString = (message) => {
  const divMessage = one('#div_MESSAGE')
  if (divMessage) {
    const list = one('#id_msg_ul', divMessage)
    const { dataset: { messageDuration: duration } } = list
    if (list) {
      const li = element(document, 'li')
      li.textContent = message
      append(list, li)
      divMessage.style.display = 'block'
      divMessage.style.visibility = 'visible'
      queueMicrotask(async () => {
        await wait(duration)
        closeByMessage(list, [li])
      })
    }
  }
}
